// Shown only when the device has no network. There is deliberately no
// "Synced" counterpart: a permanent green tick is the kind of reassurance
// people stop reading, and it would be claiming more than the app knows.

import { useT } from '@/i18n/useT';
import { useOnline } from '@/hooks/useOnline';

export function OfflinePill({ size = 'phone' }: { size?: 'phone' | 'board' }) {
  const t = useT();
  const online = useOnline();
  if (online) return null;
  const board = size === 'board';

  return (
    <span
      role="status"
      title={t.offlineNoChanges}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 7,
        padding: board ? '7px 13px' : '4px 9px',
        borderRadius: 999,
        background: 'var(--warn)',
        color: '#fff',
        font: `700 ${board ? 12 : 10}px 'Space Grotesk',sans-serif`,
        letterSpacing: '.04em',
      }}
    >
      <span
        aria-hidden="true"
        style={{ width: board ? 8 : 6, height: board ? 8 : 6, borderRadius: '50%', background: '#fff' }}
      />
      {t.offline.toUpperCase()}
    </span>
  );
}
